// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__MH3It","filesListContainer":"PosDisputesFiles_filesListContainer__3tGA2","filesButton":"PosDisputesFiles_filesButton__t_ZP3"};